import React from "react";
import { useNavigate } from "react-router-dom";
import "./ModeSelection.css";

const ModeSelection = () => {
  const navigate = useNavigate();

  return (
    <div className="mode-selection-container">
      <div className="mode-selection-card">
        <h1 className="mode-selection-title">Choose Product</h1>
        <p className="mode-selection-subtitle">
          Select where you want to continue
        </p>

        <div className="mode-selection-actions">
          <button
            className="mode-selection-btn field-btn"
            onClick={() => navigate("/Branch")}
          >
            Field
          </button>
          <button
            className="mode-selection-btn mdm-btn"
            onClick={() => navigate("/mdm")}
          >
            MDM
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModeSelection;
